export enum Province {
  Quebec = 'quebec',
  Alberta = 'alberta',
  BritishColumbia = 'britishColumbia',
  Manitoba = 'manitoba',
  Newfoundland = 'newfoundland',
  NovaScotia = 'novaScotia',
  NewBrunswick = 'newBrunswick',
  Ontario = 'ontario',
  PriceEdwardIsland = 'priceEdwardIsland',
  Saskatchewan = 'saskatchewan',
  Yukon = 'yukon',
}

// This is a hack used by Google address
// When changing it to Postal Canada, we should improve it.
// Our Province enum type should probably be only the province abbreviation. This would make it easier for
// Fortus addresses and Google addresses. We would need to change in the DB as well.
export const ProvinceAbbreviation: Map<string, Province> = new Map([
  ['QC', Province.Quebec],
  ['AB', Province.Alberta],
  ['BC', Province.BritishColumbia],
  ['MB', Province.Manitoba],
  ['NF', Province.Newfoundland],
  ['NS', Province.NovaScotia],
  ['NB', Province.NewBrunswick],
  ['ON', Province.Ontario],
  ['PE', Province.PriceEdwardIsland],
  ['SK', Province.Saskatchewan],
  ['YT', Province.Yukon],
]);
